export const containerWidth = 1080;
export const modalWidth = 1020;
export const smallModalWidth = 520;

export const newTravalerOption = {
  value: 'new',
  label: 'Add a new traveler',
};

export const newCreditCardOption = {
  value: 'new',
  label: 'New debit or credit card',
};

export const clientBalanceOption = {
  value: 'clientBalance',
  label: 'Wallet balance',
};

export const intervalMs = 120000;

export const passwordSalt = 'MTk4N0F6IQ==';
